import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ss-alinhar-desktop-direita-mobile-centro" }
const _hoisted_3 = { class: "ant-btn-group" }
const _hoisted_4 = { class: "ant-btn ant-btn-secondary ss-botoes-icones" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ss-alinhar-centro" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Teclas de Atalho - Grade de Itens")
], -1)
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_8 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 9,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  class: "acoes-item",
  style: {"margin-top":"2px"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_selecionar_produto_movimento = _resolveComponent("selecionar-produto-movimento")!
  const _component_selecionar_unidade_produto_movimento = _resolveComponent("selecionar-unidade-produto-movimento")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_estoque_produto_movimento = _resolveComponent("selecionar-estoque-produto-movimento")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_recebimento_mercadorias_item_modal = _resolveComponent("recebimento-mercadorias-item-modal")!
  const _component_buscar_itens_pedido_compra = _resolveComponent("buscar-itens-pedido-compra")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.props.editavel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_tooltip, {
                title: "Inserir Item",
                placement: "left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
                    style: {"margin-top":"4px"},
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.novoItemGrade(true)))
                  }, "Inserir item")
                ]),
                _: 1
              }),
              _createVNode(_component_a_tooltip, {
                title: "Adicionar item Pelo Pedido de Compra",
                placement: "left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-botoes-icones",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.buscarPedidoCompra && _ctx.buscarPedidoCompra(...args)))
                  }, [
                    _createVNode(_component_icone, {
                      style: {"margin-top":"2px"},
                      nome: "download-arquivo"
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_dropdown, null, {
                overlay: _withCtx(() => [
                  _createVNode(_component_a_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Shift + N")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Adicionar novo Item ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Shift + E")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Editar detalhes do produto ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Shift + D")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Distribuição de estoques ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Shift + DEL")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Deletar um item ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Shift + TAB")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Campo anterior ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("TAB")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Próximo campo ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("↑")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Campo acima ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("↓")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Campo abaixo ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_tooltip, {
                    title: "Teclas de Atalho",
                    placement: "left"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", _hoisted_4, [
                        _createVNode(_component_icone, {
                          style: {"margin-top":"2px"},
                          nome: "ajuda"
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(), _createBlock(_component_a_table, {
          key: _ctx.props.chaveItens,
          columns: _ctx.state.colunasGrade.filter(item => item.visible),
          "data-source": _ctx.computedItens,
          rowKey: "codigo",
          pagination: false,
          scroll: { y: 200},
          size: "small",
          rowClassName: "ss-table-campos",
          bordered: ""
        }, {
          emptyText: _withCtx(() => [
            _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum item adicionado ainda" })
          ]),
          bodyCell: _withCtx(({ column, record, index }) => [
            (column.key === 'acoes')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("a", {
                    class: "visualizar",
                    onClick: ($event: any) => (_ctx.editarItem(index)),
                    title: "Editar item"
                  }, [
                    _createVNode(_component_icone, { nome: "editar" })
                  ], 8, _hoisted_9),
                  (_ctx.props.editavel)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "excluir",
                        onClick: ($event: any) => (_ctx.confirmarExclusao(index)),
                        title: "Excluir item"
                      }, [
                        _createVNode(_component_icone, { nome: "excluir" })
                      ], 8, _hoisted_10))
                    : _createCommentVNode("", true),
                  (_ctx.computedItens[index].codigo > 0 && _ctx.UtilitarioGeral.validaLista(_ctx.computedItens[index].rastreabilidades) && _ctx.computedItens[index].rastreabilidades.length > 0)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        title: "Imprimir Etiqueta do Lote",
                        onClick: ($event: any) => (_ctx.imprimirEtiqueta(index))
                      }, [
                        _createVNode(_component_icone, { nome: "imprimir" })
                      ], 8, _hoisted_11))
                    : _createCommentVNode("", true)
                ]))
              : (column.key === 'Produto')
                ? (_openBlock(), _createBlock(_component_selecionar_produto_movimento, {
                    key: 1,
                    classCss: "hidden ss-campo-selecao-table ss-recebimento-mercadoria-itens",
                    classGroupCss: "ss-campo-selecao-table",
                    title: column.title,
                    dataAttributeColuna: column.key,
                    empresas: [_ctx.empresa],
                    buscarDadosAtualizados: _ctx.estrategiaBuscarDadosProdutosAtualizados(),
                    codigoSelecionado: record.itemNotaFiscal.codigoProdutoDefinicao,
                    "onUpdate:codigoSelecionado": ($event: any) => ((record.itemNotaFiscal.codigoProdutoDefinicao) = $event),
                    descricao: record.itemNotaFiscal.descricao,
                    "onUpdate:descricao": ($event: any) => ((record.itemNotaFiscal.descricao) = $event),
                    codigoUnidadePrincipal: record.itemNotaFiscal.codigoUnidadePrincipal,
                    "onUpdate:codigoUnidadePrincipal": ($event: any) => ((record.itemNotaFiscal.codigoUnidadePrincipal) = $event),
                    fatorUnidadePrincipal: record.itemNotaFiscal.fatorUnidadePrincipal,
                    "onUpdate:fatorUnidadePrincipal": ($event: any) => ((record.itemNotaFiscal.fatorUnidadePrincipal) = $event),
                    codigoInterno: record.itemNotaFiscal.codigoProduto,
                    "onUpdate:codigoInterno": ($event: any) => ((record.itemNotaFiscal.codigoProduto) = $event),
                    codigoBarras: record.itemNotaFiscal.codigoBarras,
                    "onUpdate:codigoBarras": ($event: any) => ((record.itemNotaFiscal.codigoBarras) = $event),
                    origemMercadoria: record.itemNotaFiscal.impostos.origemMercadoria,
                    "onUpdate:origemMercadoria": ($event: any) => ((record.itemNotaFiscal.impostos.origemMercadoria) = $event),
                    codigoNcm: record.itemNotaFiscal.impostos.codigoNcm,
                    "onUpdate:codigoNcm": ($event: any) => ((record.itemNotaFiscal.impostos.codigoNcm) = $event),
                    ncm: record.itemNotaFiscal.impostos.ncm,
                    "onUpdate:ncm": ($event: any) => ((record.itemNotaFiscal.impostos.ncm) = $event),
                    emDigitacao: record.emDigitacao,
                    "onUpdate:emDigitacao": ($event: any) => ((record.emDigitacao) = $event),
                    tipoRastreabilidade: record.tipoRastreabilidade,
                    "onUpdate:tipoRastreabilidade": ($event: any) => ((record.tipoRastreabilidade) = $event),
                    onChange: ($event: any) => (_ctx.trataInformacoesEspecificasProduto(index)),
                    disabled: !_ctx.props.editavel,
                    limparSelecao: false,
                    onKeydown: [
                      _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                      _withKeys(_withModifiers(($event: any) => (_ctx.confirmarExclusao(index,$event)), ["shift","exact","prevent"]), ["delete"]),
                      _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                      _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                      _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoAbaixo(record.emDigitacao, $event, column.key)), ["prevent"]), ["down"]),
                      _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoAcima(record.emDigitacao, $event, column.key)), ["prevent"]), ["up"])
                    ],
                    onKeyup: _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["enter"]))
                  }, null, 8, ["title", "dataAttributeColuna", "empresas", "buscarDadosAtualizados", "codigoSelecionado", "onUpdate:codigoSelecionado", "descricao", "onUpdate:descricao", "codigoUnidadePrincipal", "onUpdate:codigoUnidadePrincipal", "fatorUnidadePrincipal", "onUpdate:fatorUnidadePrincipal", "codigoInterno", "onUpdate:codigoInterno", "codigoBarras", "onUpdate:codigoBarras", "origemMercadoria", "onUpdate:origemMercadoria", "codigoNcm", "onUpdate:codigoNcm", "ncm", "onUpdate:ncm", "emDigitacao", "onUpdate:emDigitacao", "tipoRastreabilidade", "onUpdate:tipoRastreabilidade", "onChange", "disabled", "onKeydown"]))
                : (column.key === 'Unidade')
                  ? (_openBlock(), _createBlock(_component_selecionar_unidade_produto_movimento, {
                      classCss: "hidden ss-campo-selecao-table ss-recebimento-mercadoria-itens",
                      classGroupCss: "ss-campo-selecao-table",
                      apenasUnidadePrincipal: false,
                      dataAttributeColuna: column.key,
                      title: record.itemNotaFiscal.descricaoUnidade,
                      codigoProdutoDefinicao: record.itemNotaFiscal.codigoProdutoDefinicao,
                      editavel: _ctx.props.editavel,
                      codigoUnidadeSelecionada: record.itemNotaFiscal.codigoUnidade,
                      "onUpdate:codigoUnidadeSelecionada": ($event: any) => ((record.itemNotaFiscal.codigoUnidade) = $event),
                      descricao: record.itemNotaFiscal.descricaoUnidade,
                      "onUpdate:descricao": ($event: any) => ((record.itemNotaFiscal.descricaoUnidade) = $event),
                      sigla: record.itemNotaFiscal.siglaUnidade,
                      "onUpdate:sigla": ($event: any) => ((record.itemNotaFiscal.siglaUnidade) = $event),
                      fracionar: record.itemNotaFiscal.fracionar,
                      "onUpdate:fracionar": ($event: any) => ((record.itemNotaFiscal.fracionar) = $event),
                      casasDecimais: record.itemNotaFiscal.casasDecimaisUnidade,
                      "onUpdate:casasDecimais": ($event: any) => ((record.itemNotaFiscal.casasDecimaisUnidade) = $event),
                      fatorConversao: record.itemNotaFiscal.fatorConversao,
                      "onUpdate:fatorConversao": ($event: any) => ((record.itemNotaFiscal.fatorConversao) = $event),
                      apresentarApenasSigla: true,
                      key: ('UNIDADE' + record.itemNotaFiscal.codigoProdutoDefinicao + _ctx.props.chaveItens + index),
                      onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index,record)),
                      onChange: ($event: any) => (_ctx.unidadeAlterada(index, record)),
                      onKeydown: [
                        _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.confirmarExclusao(index, $event)), ["shift","exact","prevent"]), ["delete"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event,column.key)), ["prevent"]), ["down"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event,column.key)), ["prevent"]), ["up"])
                      ],
                      onKeyup: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["enter"]))
                    }, null, 8, ["dataAttributeColuna", "title", "codigoProdutoDefinicao", "editavel", "codigoUnidadeSelecionada", "onUpdate:codigoUnidadeSelecionada", "descricao", "onUpdate:descricao", "sigla", "onUpdate:sigla", "fracionar", "onUpdate:fracionar", "casasDecimais", "onUpdate:casasDecimais", "fatorConversao", "onUpdate:fatorConversao", "onValorDigitado", "onChange", "onKeydown"]))
                  : (column.key === 'Quantidade')
                    ? _withDirectives((_openBlock(), _createBlock(_component_selecionar_estoque_produto_movimento, {
                        empresas: [_ctx.props.empresa],
                        movimentarEntrada: true,
                        codigoProdutoDefinicao: record.itemNotaFiscal.codigoProdutoDefinicao,
                        codigoUnidadePrincipal: record.itemNotaFiscal.codigoUnidadePrincipal,
                        fatorConversaoUnidadePrincipal: record.itemNotaFiscal.fatorUnidadePrincipal,
                        codigoUnidadeSelecionada: record.itemNotaFiscal.codigoUnidade,
                        fatorConversaoUnidadeSelecionada: record.itemNotaFiscal.fatorConversao,
                        estoquesMovimento: record.estoquesMovimento,
                        "onUpdate:estoquesMovimento": ($event: any) => ((record.estoquesMovimento) = $event),
                        quantidade: record.itemNotaFiscal.quantidade,
                        "onUpdate:quantidade": ($event: any) => ((record.itemNotaFiscal.quantidade) = $event),
                        itensEstoque: record.itemNotaFiscal.estoques,
                        "onUpdate:itensEstoque": ($event: any) => ((record.itemNotaFiscal.estoques) = $event),
                        classCss: "ss-recebimento-mercadoria-itens",
                        processando: _ctx.state.carregando,
                        "onUpdate:processando": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.carregando) = $event)),
                        disabled: false,
                        index: index,
                        apresentarEstoques: (_ctx.state.apresentarEstoquesItem && _ctx.state.indexDetalhesEstoques === index),
                        popOverHover: _ctx.state.popOverHoverEstoqueItem,
                        "onUpdate:popOverHover": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.popOverHoverEstoqueItem) = $event)),
                        inputFocus: _ctx.state.inputFocusEstoqueItem,
                        "onUpdate:inputFocus": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.inputFocusEstoqueItem) = $event)),
                        identificacaoElemento: ('QTDE' + record.itemNotaFiscal.codigoProdutoDefinicao + _ctx.props.chaveItens + index),
                        key: ('SEL-QTDE' + record.itemNotaFiscal.codigoProdutoDefinicao + _ctx.props.chaveItens + index),
                        onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.quantidadeBlur()))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_component_campo_numerico, {
                            dataAttributeColuna: 'Quantidade',
                            title: 'Quantidade',
                            classCss: "hidden ss-campo-numero-table ss-recebimento-mercadoria-itens",
                            classGroupCss: "hidden ss-campo-numero-table ant-input",
                            valor: record.itemNotaFiscal.quantidade,
                            "onUpdate:valor": ($event: any) => ((record.itemNotaFiscal.quantidade) = $event),
                            emDigitacao: record.emDigitacao,
                            "onUpdate:emDigitacao": ($event: any) => ((record.emDigitacao) = $event),
                            fracionar: (record.itemNotaFiscal.fracionarUnidade),
                            quantidadeCasasDecimais: record.itemNotaFiscal.casasDecimaisUnidade,
                            disabled: false,
                            key: ('QTDE' + record.itemNotaFiscal.codigoProdutoDefinicao + _ctx.props.chaveItens + index),
                            onFocus: ($event: any) => (_ctx.quantidadeFoco(index)),
                            onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.quantidadeBlur())),
                            onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index,record)),
                            onKeyup: _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                            onKeydown: [
                              _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                              _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, 'Quantidade')), ["prevent"]), ["down"])),
                              _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, 'Quantidade')), ["prevent"]), ["up"]))
                            ]
                          }, null, 8, ["valor", "onUpdate:valor", "emDigitacao", "onUpdate:emDigitacao", "fracionar", "quantidadeCasasDecimais", "onFocus", "onValorDigitado", "onKeydown"]))
                        ]),
                        _: 2
                      }, 1032, ["empresas", "codigoProdutoDefinicao", "codigoUnidadePrincipal", "fatorConversaoUnidadePrincipal", "codigoUnidadeSelecionada", "fatorConversaoUnidadeSelecionada", "estoquesMovimento", "onUpdate:estoquesMovimento", "quantidade", "onUpdate:quantidade", "itensEstoque", "onUpdate:itensEstoque", "processando", "index", "apresentarEstoques", "popOverHover", "inputFocus", "identificacaoElemento"])), [
                        [_vShow, (record.itemNotaFiscal.codigoProdutoDefinicao > 0)]
                      ])
                    : (column.key === 'ValorUnitario')
                      ? (_openBlock(), _createBlock(_component_campo_numerico, {
                          key: 4,
                          dataAttributeColuna: column.key,
                          valor: record.itemNotaFiscal.precoUnitario,
                          "onUpdate:valor": ($event: any) => ((record.itemNotaFiscal.precoUnitario) = $event),
                          monetario: true,
                          quantidadeCasasDecimais: record.itemNotaFiscal.casasDecimaisPrecoUnitario,
                          disabled: !_ctx.props.editavel,
                          classCss: "ss-campo-numero-table hidden ss-recebimento-mercadoria-itens",
                          classGroupCss: "hidden ss-campo-numero-table",
                          onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index,record)),
                          onKeydown: [
                            _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                            _withKeys(_withModifiers(($event: any) => (_ctx.confirmarExclusao(index, $event)), ["shift","exact","prevent"]), ["delete"]),
                            _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                            _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                            _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, column.key)), ["prevent"]), ["down"]),
                            _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, column.key)), ["prevent"]), ["up"])
                          ],
                          onKeyup: _cache[12] || (_cache[12] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"]))
                        }, null, 8, ["dataAttributeColuna", "valor", "onUpdate:valor", "quantidadeCasasDecimais", "disabled", "onValorDigitado", "onKeydown"]))
                      : (column.key === 'Icms')
                        ? (_openBlock(), _createBlock(_component_campo_numerico, {
                            key: 5,
                            dataAttributeColuna: column.key,
                            valor: record.itemNotaFiscal.impostos.icms.aliquotaIcms,
                            "onUpdate:valor": ($event: any) => ((record.itemNotaFiscal.impostos.icms.aliquotaIcms) = $event),
                            percentual: true,
                            disabled: !_ctx.props.editavel,
                            classCss: "ss-campo-numero-table hidden ss-recebimento-mercadoria-itens",
                            classGroupCss: "hidden ss-campo-numero-table",
                            onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index,record)),
                            onKeydown: [
                              _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.confirmarExclusao(index, $event)), ["shift","exact","prevent"]), ["delete"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, column.key)), ["prevent"]), ["down"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, column.key)), ["prevent"]), ["up"])
                            ],
                            onKeyup: _cache[13] || (_cache[13] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"]))
                          }, null, 8, ["dataAttributeColuna", "valor", "onUpdate:valor", "disabled", "onValorDigitado", "onKeydown"]))
                        : (column.key === 'Ipi')
                          ? (_openBlock(), _createBlock(_component_campo_numerico, {
                              key: 6,
                              dataAttributeColuna: column.key,
                              valor: record.itemNotaFiscal.impostos.ipi.aliquotaIpi,
                              "onUpdate:valor": ($event: any) => ((record.itemNotaFiscal.impostos.ipi.aliquotaIpi) = $event),
                              percentual: true,
                              disabled: !_ctx.props.editavel,
                              classCss: "ss-campo-numero-table hidden ss-recebimento-mercadoria-itens",
                              classGroupCss: "hidden ss-campo-numero-table",
                              onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index,record)),
                              onKeydown: [
                                _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.confirmarExclusao(index, $event)), ["shift","exact","prevent"]), ["delete"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, column.key)), ["prevent"]), ["down"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, column.key)), ["prevent"]), ["up"])
                              ],
                              onKeyup: _cache[14] || (_cache[14] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"]))
                            }, null, 8, ["dataAttributeColuna", "valor", "onUpdate:valor", "disabled", "onValorDigitado", "onKeydown"]))
                          : (column.key === 'Desconto')
                            ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                key: 7,
                                dataAttributeColuna: column.key,
                                valor: record.itemNotaFiscal.valorDesconto,
                                "onUpdate:valor": ($event: any) => ((record.itemNotaFiscal.valorDesconto) = $event),
                                monetario: true,
                                disabled: !_ctx.props.editavel,
                                classCss: "hidden ss-campo-numero-table ss-recebimento-mercadoria-itens",
                                classGroupCss: "hidden ss-campo-numero-table",
                                onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index,record)),
                                onKeydown: [
                                  _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.confirmarExclusao(index, $event)), ["shift","exact","prevent"]), ["delete"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoProximoElementoDesconto(record.emDigitacao, index, $event)), ["exact"]), ["tab"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, column.key)), ["prevent"]), ["down"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, column.key)), ["prevent"]), ["up"])
                                ],
                                onKeyup: _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoProximoElementoDesconto(record.emDigitacao, index, $event)), ["exact"]), ["enter"])
                              }, null, 8, ["dataAttributeColuna", "valor", "onUpdate:valor", "disabled", "onValorDigitado", "onKeydown", "onKeyup"]))
                            : (column.key === 'Total')
                              ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                  key: 8,
                                  title: column.title,
                                  valor: record.itemNotaFiscal.valorTotal,
                                  quantidadeCasasDecimais: 2,
                                  monetario: true,
                                  disabled: true,
                                  classGroupCss: "hidden ss-campo-numero-table",
                                  classCss: "hidden ss-campo-numero-table"
                                }, null, 8, ["title", "valor"]))
                              : (column.key === 'Item')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("span", null, [
                                      _createElementVNode("a", {
                                        onClick: ($event: any) => (_ctx.editarItem(index))
                                      }, [
                                        _createElementVNode("span", null, _toDisplayString(record.itemNotaFiscal.descricao), 1)
                                      ], 8, _hoisted_13)
                                    ]),
                                    _createElementVNode("span", null, "Quantidade: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.itemNotaFiscal.quantidade, 2)) + "(" + _toDisplayString(record.itemNotaFiscal.descricaoUnidade) + ") ", 1),
                                    _createElementVNode("span", null, "Vlr Unitário: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.itemNotaFiscal.precoUnitario, 2, true)), 1),
                                    _createElementVNode("span", null, "Desconto: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.itemNotaFiscal.valorDesconto, 2, true)), 1),
                                    _createElementVNode("span", null, "Total: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.itemNotaFiscal.valorTotal, 2, true)), 1),
                                    _createElementVNode("div", _hoisted_14, [
                                      _createElementVNode("a", {
                                        class: "visualizar",
                                        onClick: ($event: any) => (_ctx.editarItem(index))
                                      }, [
                                        _createVNode(_component_icone, { nome: "editar" })
                                      ], 8, _hoisted_15),
                                      (_ctx.props.editavel)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            class: "excluir",
                                            onClick: ($event: any) => (_ctx.confirmarExclusao(index))
                                          }, [
                                            _createVNode(_component_icone, { nome: "excluir" })
                                          ], 8, _hoisted_16))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data-source"]))
      ])
    ]),
    _createVNode(_component_recebimento_mercadorias_item_modal, {
      empresa: _ctx.props.empresa,
      pessoa: _ctx.props.pessoa,
      totalNota: _ctx.props.totalNota,
      estoquesDisponiveis: _ctx.props.estoquesDisponiveis,
      item: _ctx.state.itemSelecionado,
      existeAnterior: _ctx.state.existeAnterior,
      existeProximo: _ctx.state.existeProximo,
      visivel: _ctx.state.exibirDetalhesItem,
      "onUpdate:visivel": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.exibirDetalhesItem) = $event)),
      editavel: _ctx.props.editavel,
      tiposCustosCadastrados: _ctx.props.tiposCustosCadastrados,
      onSalvar: _ctx.salvarItem,
      onProximoItem: _ctx.proximoItem,
      onItemAnterior: _ctx.itemAnterior
    }, null, 8, ["empresa", "pessoa", "totalNota", "estoquesDisponiveis", "item", "existeAnterior", "existeProximo", "visivel", "editavel", "tiposCustosCadastrados", "onSalvar", "onProximoItem", "onItemAnterior"]),
    _createVNode(_component_buscar_itens_pedido_compra, {
      visivel: _ctx.state.exibirBuscaPedidoCompra,
      "onUpdate:visivel": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.exibirBuscaPedidoCompra) = $event)),
      empresa: _ctx.props.empresa,
      pessoa: _ctx.props.pessoa,
      filtros: _ctx.state.filtrosPedido,
      ignorarDevolvidos: true,
      codigoFornecedor: _ctx.props.codigoFornecedor,
      onConfirmacao: _ctx.adicionarItensPedido
    }, null, 8, ["visivel", "empresa", "pessoa", "filtros", "codigoFornecedor", "onConfirmacao"]),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivosPdf
    }, null, 8, ["arquivos"])
  ]))
}